import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import DateRangePicker from "../DateRangePicker";
import "./Filters.scss";
import { useAnalytics } from "../../context/AnalyticsContext";



const Filters = ({ onDateTimeChanged, variant = "bar" }) => {

  const { updateDateRange } = useAnalytics();

  const [startDate, setStartDate] = useState(null);

  const [endDate, setEndDate] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const lastPropagatedRangeRef = useRef("");

  

  const setDateTimes = useCallback(({ start, end }) => {
    if (start) setStartDate(start);
    if (end) setEndDate(end);
    onDateTimeChanged?.({ start, end });
  }, [onDateTimeChanged]);

  const rangeKey = useMemo(() => {
    if (!startDate || !endDate) return "";
    return `${startDate}|${endDate}`;
  }, [startDate, endDate]);

  useEffect(() => {
    if (!rangeKey) return;
    if (lastPropagatedRangeRef.current === rangeKey) return;

    lastPropagatedRangeRef.current = rangeKey;
    updateDateRange({ startDate, endDate });
  }, [rangeKey, startDate, endDate, updateDateRange]);

  useEffect(() => {
    const handleScroll = () => {
      const nextIsScrolled = window.scrollY > 8;
      setIsScrolled((prev) => (prev === nextIsScrolled ? prev : nextIsScrolled));
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={`filters filters--${variant}${isScrolled ? " is-scrolled" : ""}`}>
      <DateRangePicker
        compact={variant === "compact"}
        dateRange={{ start: startDate, end: endDate }}
        onRangeUpdated={setDateTimes}
      />
    </div>
  );

 
};

export default Filters;
